import { useQuery } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { MissingItemsListItem } from "../../inventory.types";
import { requestMissingItems } from "./missingItems.request";

const useGetDamagedItemsList = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<MissingItemsListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["missing-items", requestParams],
    queryFn: async () => await requestMissingItems(requestParams),
    ...options
  });

  return { missingItemsList: data?.data, meta: data?.meta, ...rest };
};

export default useGetDamagedItemsList;
